import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../utils/services/auth.service';
import {HeaderService} from '../../../utils/services/header.service';

@Component({
    selector: 'app-home',
    templateUrl: './prices.component.html',
    styleUrls: ['./prices.component.css']
})
export class PricesComponent {

    constructor(
        public authService: AuthService,
        private headerService: HeaderService) {
            this.headerService.setTitle('Verity Prices - Prices View');
    }
}
